import React from 'react';
import UserContext from "../../context/UserContext";
import {
  SidebarExternalLink,
  SidebarLink,
  SidebarSeparator,
  SidebarTitle
} from "../../ui-kit/src/sidebar/SidebarComponents";
import {Redirect, useLocation} from "react-router-dom";
import {
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav
  //@ts-ignore
} from "@coreui/react";

export default function DefaultSidebar() {
  const location = useLocation();

  return (
    <AppSidebar fixed display="lg" >
      <AppSidebarHeader />
      <AppSidebarForm/>
      <UserContext.Consumer>
        {userInfo => <AppSidebarNav>
          <SidebarTitle title={"UPLOAD"} />
          {/*<SidebarLink title={'Collections'} icon={'fa-thin fa-rectangle-history'} link={'/product/collections'}*/}
          {/*             iconFontSize={'0.875rem'} location={location} dataTestId={"sidebar-link-collections"}/>*/}
          <SidebarLink title={'Images'} icon={'fa-thin fa-image'} link={'/images'}
                           iconFontSize={'0.938rem'} location={location} dataTestId={"sidebar-link-images"}/>
          <SidebarLink title={'Marketing'} icon={'fa-thin fa-megaphone'} link={'/marketing'}
                       iconFontSize={'0.813rem'} location={location} dataTestId={"sidebar-link-marketing"}/>
          <SidebarTitle title={"DATA"} />
          <SidebarSeparator />
          <SidebarLink title={'Orders'} icon={'fa-thin fa-clipboard-list'} link={'/orders'}
                                      location={location} dataTestId={"sidebar-link-orders"}/>
          <SidebarLink title={'Products'} icon={'fa-thin fa-shirt'} link={'/product/catalog'} iconFontSize={'0.875rem'}
                       location={location} dataTestId={"sidebar-link-products"}/>
          <SidebarTitle title={"CONNECTIONS"} />
          <SidebarSeparator />
          {/*{userInfo?.isSystemAdmin && <SidebarLink title={'Input'} icon={'fa-thin fa-right-to-bracket'} link={'/inputs'}*/}
          {/*                                        location={location} dataTestId={"sidebar-link-input"}/>}*/}
          <SidebarLink title={'Outputs'} icon={'fa-thin fa-bolt-lightning'} link={'/output'}
                       location={location} dataTestId={"sidebar-link-output"}/>
          {/*<SidebarLink title={'Automations'} icon={'fa-thin fa-gear'} link={'/automations'}*/}
          {/*             location={location} dataTestId={"sidebar-link-automations"}/>*/}
          <SidebarLink title={'Retailers'} icon={'fa-thin fa-store'} link={'/distributedata/retailers'}
                       iconFontSize={'0.875rem'} location={location} dataTestId={"sidebar-link-retailers"}/>
          <SidebarTitle title={"HELP"} />
          <SidebarSeparator />
          <SidebarExternalLink title={'Help Centre'} icon={'fa-thin fa-life-ring'} link={'https://intercom.help/vuuh/en/'}
                       iconFontSize={'0.875rem'} dataTestId={"sidebar-link-help-centre"}/>
        </AppSidebarNav>}
      </UserContext.Consumer>
      <AppSidebarFooter/>
      <AppSidebarMinimizer />
    </AppSidebar>
  )
}